import { useState } from 'react';
import { roundBook, fmtBook } from '../../utils/casinoBook';

function formatAmount(n) {
  if (!n && n !== 0) return '';
  const num = Number(n);
  if (num >= 100000) return `${num / 100000}L`;
  if (num >= 1000) return `${num / 1000}K`;
  return String(num);
}

function isSusp(item) {
  return !item || item.gstatus === 'SUSPENDED' || item.gstatus === '0' || item.gstatus === 0;
}

function bookOf(exposures, item) {
  const v = exposures?.[`sid:${item?.sid}`] ?? exposures?.[item?.nat];
  return v || 0;
}

function bookValue(exposures, item) {
  const v = bookOf(exposures, item);
  return v ? roundBook(v) : 0;
}

function bookClass(exposures, item) {
  const v = bookOf(exposures, item);
  if (!v) return 'book-black';
  return v < 0 ? 'book-red' : 'book-green';
}

/* Back + Lay market — "Who Will Goal Next?" / "Method Of Next Goal" */
function BackLayMarket({ id, title, items, onBet, exposures }) {
  const [open, setOpen] = useState(true);
  if (!items || items.length === 0) return null;

  return (
    <div className="market-6">
      <div className="bet-table">
        <div data-toggle="collapse" data-target={`#${id}`} aria-expanded={open ? 'true' : 'false'} className="bet-table-header" onClick={() => setOpen((v) => !v)}>
          <div className="nation-name">
            <span title={title}>{'\n          ' + title + '\n        '}</span>
          </div>
        </div>
        {' '}
        <div id={id} className={`bet-table-body collapse${open ? ' show' : ''} container-fluid container-fluid-5`}>
          <div className="row row5 d-none-mobile">
            <div className="col-6 col-md-12">
              <div className="fancy-tripple">
                <div className="bet-table-row">
                  <div className="nation-name"></div>
                  {' '}
                  <div className="back bl-title back-title">Back</div>
                  {' '}
                  <div className="lay bl-title lay-title">Lay</div>
                </div>
              </div>
            </div>
          </div>
          {' '}
          <div className="row row5">
            {items.map((item, i) => {
              const suspended = isSusp(item);
              const nat = item?.nat ?? '';
              const book = bookValue(exposures, item);
              return (
                <div key={item?.sid ?? i} className="col-6 col-md-12">
                  <div className="fancy-tripple">
                    <div className="bet-table-mobile-row d-none-desktop">
                      <div className="bet-table-mobile-team-name">
                        <span>{nat}</span>
                        {' '}
                        <span className={bookClass(exposures, item)}>{fmtBook(book)}</span>
                      </div>
                    </div>
                    {' '}
                    <div className="bet-table-row">
                      <div className="nation-name d-none-mobile">
                        <p>{'\n                    ' + nat + '\n                  '}</p>
                        {' '}
                        <p className={`mb-0 ${bookClass(exposures, item)}`}>{fmtBook(book)}</p>
                      </div>
                      {' '}
                      <div
                        data-title={suspended ? 'SUSPENDED' : item?.gstatus || 'OPEN'}
                        className={`bl-box back${Number(item?.b) ? '' : ' no-val'}${suspended ? ' suspended' : ''}`}
                        onClick={() => !suspended && onBet?.(item, 'back')}
                      >
                        <span className="d-block odds">{Number(item?.b) ? item.b : '\u2014'}</span>
                        {' '}
                        {Number(item?.bs) ? <span className="d-block">{formatAmount(item.bs)}</span> : null}
                      </div>
                      {' '}
                      <div
                        className={`bl-box lay${Number(item?.l) ? '' : ' no-val'}${suspended ? ' suspended' : ''}`}
                        onClick={() => !suspended && onBet?.(item, 'lay')}
                      >
                        <span className="d-block odds">{Number(item?.l) ? item.l : '\u2014'}</span>
                        {' '}
                        {Number(item?.ls) ? <span className="d-block">{formatAmount(item.ls)}</span> : null}
                      </div>
                      {' '}
                      <div className="fancy-min-max">
                        {'\n                  Min:'}
                        <span>{formatAmount(item?.min ?? '')}</span>
                        {'\n                  Max:'}
                        <span>{formatAmount(item?.max ?? '')}</span>
                      </div>
                    </div>
                    {' '}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

/* Back-only two-column market — "Method Of Combination Goal" */
function ComboMarket({ id, title, items, onBet, exposures }) {
  const [open, setOpen] = useState(true);
  if (!items || items.length === 0) return null;

  const headerCell = (
    <div className="fancy-tripple">
      <div className="bet-table-row">
        <div className="nation-name"></div>
        {' '}
        <div className="back bl-title back-title">Back</div>
      </div>
    </div>
  );

  return (
    <div className="market-comb">
      <div className="bet-table">
        <div data-toggle="collapse" data-target={`#${id}`} aria-expanded={open ? 'true' : 'false'} className="bet-table-header" onClick={() => setOpen((v) => !v)}>
          <div className="nation-name">
            <span title={title}>{'\n          ' + title + '\n        '}</span>
          </div>
        </div>
        {' '}
        <div id={id} className={`bet-table-body collapse${open ? ' show' : ''} container-fluid container-fluid-5`}>
          <div className="row row5 d-none-mobile">
            <div className="col-6 col-md-6">{headerCell}</div>
            {' '}
            <div className="col-6 col-md-6">{headerCell}</div>
          </div>
          {' '}
          <div className="row row5">
            {items.map((item, i) => {
              const suspended = isSusp(item);
              const nat = item?.nat ?? '';
              const book = bookValue(exposures, item);
              return (
                <div key={item?.sid ?? i} className="col-6 col-md-6">
                  <div className="fancy-tripple">
                    <div className="bet-table-mobile-row d-none-desktop">
                      <div className="bet-table-mobile-team-name">
                        <span>{nat}</span>
                        {' '}
                        <span className={bookClass(exposures, item)}>{fmtBook(book)}</span>
                      </div>
                    </div>
                    {' '}
                    <div className="bet-table-row">
                      <div className="nation-name d-none-mobile">
                        <p>{'\n                    ' + nat + '\n                  '}</p>
                        {' '}
                        <p className={`mb-0 ${bookClass(exposures, item)}`}>{fmtBook(book)}</p>
                      </div>
                      {' '}
                      <div
                        data-title={suspended ? 'SUSPENDED' : item?.gstatus || 'OPEN'}
                        className={`bl-box back${Number(item?.b) ? '' : ' no-val'}${suspended ? ' suspended' : ''}`}
                        onClick={() => !suspended && onBet?.(item, 'back')}
                      >
                        <span className="d-block odds">{Number(item?.b) ? item.b : '\u2014'}</span>
                        {' '}
                        {Number(item?.bs) ? <span className="d-block">{formatAmount(item.bs)}</span> : null}
                      </div>
                      {' '}
                      <div className="fancy-min-max">
                        {'\n                  Min:'}
                        <span>{formatAmount(item?.min ?? '')}</span>
                        {'\n                  Max:'}
                        <span>{formatAmount(item?.max ?? '')}</span>
                      </div>
                    </div>
                    {' '}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

// Exclusive method names (not "No Goal" since it appears in both markets)
const EXCLUSIVE_METHODS = ['shot goal', 'header goal', 'penalty goal', 'free kick goal'];

// Combination selections read "<Player> and <Method>"
const isCombo = (s) =>
  ['combination', 'combo'].includes((s.subtype || '').toLowerCase()) ||
  / and /i.test(s.nat || '');

function BetTableGoal2({ gameData, onBet, exposures }) {
  const sub = gameData?.sub ?? [];

  const combos = sub
    .filter(isCombo)
    .slice()
    .sort((a, b) => ((a.sid % 100) - (b.sid % 100)) || (a.sid - b.sid));
  const rest = sub.filter((s) => !isCombo(s));

  let playersMarket;
  let methodsMarket;

  // Try discriminator fields first (goal API sends subtype: "player" / "goal")
  const byPlayer = rest.filter((s) => s.subtype === 'player');
  const byMethod = rest.filter((s) => s.subtype === 'goal' || s.subtype === 'method');

  if (byPlayer.length > 0 || byMethod.length > 0) {
    playersMarket = byPlayer;
    methodsMarket = byMethod;
  } else {
    // Split by position: find where the first exclusive method name starts
    const splitIndex = rest.findIndex((s) =>
      EXCLUSIVE_METHODS.includes((s.nat || '').toLowerCase().trim())
    );
    if (splitIndex > 0) {
      playersMarket = rest.slice(0, splitIndex);
      methodsMarket = rest.slice(splitIndex);
    } else {
      playersMarket = rest;
      methodsMarket = [];
    }
  }

  return (
    <>
      <BackLayMarket
        id="market-player"
        title="Who Will Goal Next?"
        items={playersMarket}
        onBet={onBet}
        exposures={exposures}
      />
      {' '}
      <BackLayMarket
        id="market-method"
        title="Method Of Next Goal"
        items={methodsMarket}
        onBet={onBet}
        exposures={exposures}
      />
      {' '}
      <ComboMarket
        id="market-combo"
        title="Method Of Combination Goal"
        items={combos}
        onBet={onBet}
        exposures={exposures}
      />
    </>
  );
}

export default BetTableGoal2;
